import Permissions from '@app/src/auth/permissions'
import { usePermissions } from '@app/src/auth/permissions/usePermissions'
import { ResourceTypes } from '@app/src/wf-constants'
import type { ProviderType } from '@app/src/wf-constants'

// An accessor always holds one of these three permissions. The fallback is only here because
// getWithPermission is typed to return undefined without one, and "company" is the neutral word -
// the platform never calls an organization a "provider" in front of a user.
const types: Record<string, ProviderType> = {
  [Permissions.SOURCING_USER]: ResourceTypes.Supplier,
  [Permissions.INVESTMENT_USER]: ResourceTypes.Investee,
  [Permissions.FINANCE_USER]: ResourceTypes.Company,
  fallback: ResourceTypes.Company,
}

const useCurrentProviderType = (): ProviderType => {
  const { getWithPermission } = usePermissions()

  return getWithPermission(types) ?? ResourceTypes.Company
}

export default useCurrentProviderType
